// extracted by mini-css-extract-plugin
module.exports = {"Content":"SectionPlacePictureList_Content__24Qf0"};